import http from '../_httpHandlers';
import { config } from '../_config';
import { ILicense, ISecureService } from '../_types/interfaces';

const uri = config.backendAddress;

const getCode = async (): Promise<string> => {
    return await http.get(`${uri}/GetCode`, 'text');
};

const getServicesCode = async (): Promise<string> => {
    return await http.get(`${uri}/GetServicesCode`, 'text');
};

const getServerAddress = async (): Promise<string> => {
    return await http.get(`${uri}/GetServerAddress`, 'text');
};

const getLicensesForServices = async (): Promise<Array<ILicense>> => {
    return await http.get(`${uri}/GetLicensesForServices`);
};


export const secureServices: ISecureService = {
    getCode,
    getServicesCode,
    getServerAddress,
    getLicensesForServices
};